const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

export const getAstroBaseUrl = () => {
    const configured = trimTrailingSlash(
        process.env.REACT_APP_PUBLIC_ASTRO_URL ||
        process.env.REACT_APP_ASTRO_URL
    );

    if (configured) return configured;

    if (typeof window !== "undefined") {
        const { protocol, hostname } = window.location;
        if (hostname === "localhost" || hostname === "127.0.0.1") {
            return `${protocol}//${hostname}:4321`;
        }
    }

    return "";
};

export const astroHref = (path = "/") => {
    const cleanPath = `/${String(path || "/").replace(/^\/+/, "")}`;
    return `${getAstroBaseUrl()}${cleanPath}`;
};
